import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Spin } from "antd"; // Ant Design Modal and Spinner

const AgentRegistration = () => {
  const apiUrl = import.meta.env.VITE_API_URL; // API Base URL
  const [formFields, setFormFields] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formState, setFormState] = useState({}); // State to store form data
  const [submitting, setSubmitting] = useState(false); // NEW

  // Fetch form fields from the API
  useEffect(() => {
    const fetchFormFields = async () => {
      try {
        const response = await axios.get(`${apiUrl}/forms/1`);
        setFormFields(response.data.fields || []);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching form fields:", error);
        setIsLoading(false);
      }
    };

    fetchFormFields();
  }, [apiUrl]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    let formData = new FormData();
    formData.append("form_id", 1);

    formFields.forEach((field) => {
      const value = formState[field.name];

      if ((field.field_type === "image" || field.field_type === "file") && value) {
        const file = value[0];
        formData.append(`file_${field.id}`, file);
        formData.append(`field_${field.id}`, "");
      } else if (value || field.field_type === "checkbox" || field.field_type === "radio") {
        formData.append(`field_${field.id}`, value || "");
      }
    });

    try {
      const response = await axios.post(`${apiUrl}/form_responses/submit/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Modal.success({
        title: "Success!",
        content: "Form submitted successfully!",
        onOk: () => window.location.reload(),
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      Modal.error({
        title: "Submission Failed",
        content: "Something went wrong. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };
  
  
  
  

  // // Submit the form data after conversion
  // const submitFormData = async (formData) => {
  //   try {
  //     const response = await axios.post(`${apiUrl}/form_responses/submit/`, formData, {
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     console.log("Form submitted successfully:", response.data);
  //     alert("Form submitted successfully!");
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     alert("Error submitting form. Please try again.");
  //   }
  // };

  // Handle change for form inputs
  const handleInputChange = (e) => {
    const { name, value, type, files, checked } = e.target;
    if (type === "checkbox") {
      setFormState((prev) => ({
        ...prev,
        [name]: prev[name]
          ? checked
            ? [...prev[name], value]
            : prev[name].filter((v) => v !== value)
          : checked
          ? [value]
          : [],
      }));
    } else if (type === "radio") {
      setFormState((prev) => ({ ...prev, [name]: value }));
    } else if (type === "file") {
      setFormState((prev) => ({ ...prev, [name]: files }));
    } else {
      setFormState((prev) => ({ ...prev, [name]: value }));
    }
  };

  return (
    <div className="bg-black lg:min-h-screen flex items-center justify-center px-4 py-10">
      <div className="bg-white shadow-lg rounded-lg lg:max-w-4xl w-full p-8 border-t-8 border-[#e6b800]">
        <h2 className="text-3xl font-bold text-center text-black mb-6">
          Become Our Agent
        </h2>
        <p className="text-center text-gray-700 mb-8">
          Fill out the form below to join us as an agent.
        </p>

        {isLoading ? (
          <p className="text-center text-gray-700">Loading form fields...</p>
        ) : (
          <form className="space-y-6" onSubmit={handleSubmit}>
            {formFields.map((field, index) => (
              <div key={index}>
                <label
                  className="block text-black font-medium mb-2"
                  htmlFor={field.name}
                >
                  {field.name}
                  {field.required && <span className="text-red-500"> *</span>}
                </label>

                {/* Handle text and email fields */}
                {field.field_type === "text" && (
                  <input
                    type="text"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  />
                )}
                {field.field_type === "email" && (
                  <input
                    type="email"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  />
                )}

                {/* Handle phone number input */}
                {field.field_type === "phone" && (
                  <input
                    type="tel"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  />
                )}

                {/* Handle image upload (file input) */}
                {(field.field_type === "image" || field.field_type === "file") && (
                  <input
                    type="file"
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    required={field.required}
                    onChange={handleInputChange}
                  />
                )}

                {/* Handle text area */}
                {field.field_type === "textarea" && (
                  <textarea
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    placeholder={`Enter your ${field.name}`}
                    rows="3"
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  ></textarea>
                )}

                {/* Handle choice (checkbox) */}
                {field.field_type === "checkbox" && (
                  <div className="flex flex-wrap  items-center gap-10 justify-center ">
                    {field.options &&
                      field.options.map((option, i) => (
                        <label key={i} className="flex items-center">
                          <input
                            type="checkbox"
                            name={field.name}
                            value={option}
                            checked={formState[field.name]?.includes(option)}
                            onChange={handleInputChange}
                            className="text-[#e6b800] border-gray-300 rounded focus:ring-2 focus:ring-[#e6b800]"
                          />
                          <span className="text-gray-700 focus:bg-alf" >{option}</span>
                        </label>
                      ))}
                  </div>
                )}

                {/* Handle choice (radio) */}
                {field.field_type === "radio" && (
                  <div className="space-y-2">
                    {field.options &&
                      field.options.map((option, i) => (
                        <label key={i} className="flex items-center space-x-2">
                          <input
                            type="radio"
                            name={field.name}
                            value={option}
                            checked={formState[field.name] === option}
                            onChange={handleInputChange}
                            className="text-[#e6b800] border-gray-300  focus:ring-2 focus:ring-[#e6b800]"
                          />
                          <span className="text-gray-700">{option}</span>
                        </label>
                      ))}
                  </div>
                )}

                {/* Handle select dropdown */}
                {field.field_type === "select" && (
                  <select
                    name={field.name}
                    id={field.name}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e6b800]"
                    required={field.required}
                    value={formState[field.name] || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select {field.name}</option>
                    {field.options &&
                      field.options.map((option, i) => (
                        <option key={i} value={option}>
                          {option}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            ))}

<button
              type="submit"
              className="w-full bg-[#e6b800] text-white py-3 px-6 rounded-lg mt-4 hover:bg-[#c19e00] focus:outline-none focus:ring-2 focus:ring-[#e6b800] flex justify-center items-center gap-2"
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <Spin size="small" /> Submitting...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AgentRegistration;
 